import type { RouteRecordRaw } from 'vue-router'
import Case from './Case.vue'
import CaseBreadcrumbs from './CaseBreadcrumbs.vue'
import CaseNotFound from './CaseNotFound.vue'
import NewCase from './NewCase.vue'
import CaseSidebar from './Sidebar/CaseSidebar.vue'

export const casesRoutes: RouteRecordRaw[] = [
  {
    path: '/:workspaceId/cases/new',
    name: 'NewCase',
    props: {
      default: (route) => ({
        workspaceId: route.params.workspaceId,
        agentId: route.query.agentId,
        entityId: route.query.entityId,
      }),
      BreadCrumbs: (route) => ({ workspaceId: route.params.workspaceId }),
    },
    components: { default: NewCase, BreadCrumbs: CaseBreadcrumbs },
  },
  {
    path: '/:workspaceId/cases/:caseId',
    name: 'Case',
    props: {
      default: (route) => ({
        workspaceId: route.params.workspaceId,
        agentId: route.query.agentId,
        caseId: route.params.caseId,
      }),
      BreadCrumbs: (route) => ({
        workspaceId: route.params.workspaceId,
        caseId: route.params.caseId,
      }),
    },
    components: { default: Case, BreadCrumbs: CaseBreadcrumbs },
    children: [{ path: 'details', name: 'CaseDetails', component: CaseSidebar }],
  },
  {
    path: '/:workspaceId/cases/:caseId',
    name: 'CaseNotFound',
    props: {
      default: (route) => ({
        workspaceId: route.params.workspaceId,
        agentId: route.query.agentId,
        caseId: route.params.caseId,
      }),
      BreadCrumbs: (route) => ({
        workspaceId: route.params.workspaceId,
      }),
    },
    components: { default: CaseNotFound, BreadCrumbs: CaseBreadcrumbs },
  },
]
